module.exports = __webpack_public_path__ + "img/blank.c6dd122.png";